export default "__VITE_ASSET__CwyWzy3f__"